import { Button, InlineText2 } from '@cian/ui-kit';

import * as React from 'react';

import { IconDontKnowMan } from '../../UI/Icons/IconDontKnowMan';

import { CoworkingPlacementApplicationModal } from '../CoworkingPlacementApplicationModal';

import { CoworkingPlacementApplicationProps } from './types';
import * as styles from './CoworkingPlacementApplication.css';

export const CoworkingPlacementApplication: React.FC<CoworkingPlacementApplicationProps> = (props) => {
  const { httpApi, logger } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['icon-container']}>
        <IconDontKnowMan />
      </div>
     <div className={styles['content-container']}>
       <div className={styles['description']}>
         <InlineText2 as="span" color="black_100" fontWeight="normal">
           Размещать объявления этого типа могут только операторы коворкинга.
         </InlineText2>
         <InlineText2 as="span" color="black_100" fontWeight="normal">
           Чтобы получить доступ, отправьте заявку.
         </InlineText2>
       </div>
       <CoworkingPlacementApplicationModal httpApi={httpApi} logger={logger}>
         {(visible, toggleModalVisibility) => (
           <div className={styles['customButton']}>
             <Button
               fullWidth={false}
               onClick={(e) => {
                 toggleModalVisibility();
                 e.stopPropagation();
               }}
               size="XS"
               theme="fill_primary"
               type="button"
             >
               Отправить заявку
             </Button>
           </div>
         )}
       </CoworkingPlacementApplicationModal>
     </div>
    </div>
  );
};

CoworkingPlacementApplication.displayName = 'CoworkingPlacementApplication';
